const drawerWidth = 240;

const styles = theme => ({
  container: {
    maxWidth: '1280px',
    padding: '0px',
    '@media (min-width:980px) and (max-width:1300px)': {
      maxWidth: '100%',
      padding: '0px 24px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0px 16px',
    },
  },
  appBar: {
    background: '#FFFFFF',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin', 'background'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '& $menuButton': {
      color: theme.palette.type === 'dark' ? theme.palette.primary.light : theme.palette.primary.main,
      zIndex: 10,
    },
    '& $headerTitle': {
      left: theme.spacing(3),
    },
    [theme.breakpoints.up('xs')]: {
      display: 'flex',
    },
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  headerLogo: {
    maxWidth: 100,
  },
  attachedBar: {
    position: 'relative',
    '& $menuButton': {
      margin: `0 ${theme.spacing(2)}px`,
    },
  },
  maintainance: {
    background: theme.palette.primary.main,
    padding: '1.5%',
    textAlign: 'center',
    color: '#ffffff',
    fontSize: '17px',
    fontWeight: 'bold',
    zIndex: 9999,
  },
  successImg: {
    width: '50px',
    height: '50px',
  },
  appMenu: {
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(0.5)}px 0`,
    },
  },
  fixed: {
    position: 'fixed',
    left: 0,
    top: 0,
    [theme.breakpoints.up('lg')]: {
      top: theme.spacing(1) * -8,
    },
    '& nav': {
      padding: '16px 0',
    },
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
    fontSize: 16,
    margin: 0,
    fontWeight: 500,
    textDecoration: 'none',
    color: theme.palette.text.primary,
    paddingLeft: '0px',
    '& img': {
      marginRight: '8px',
    },
  },
  brandIpad: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,

    width: '110px',
  },
  swipeDrawerPaper: {
    width: drawerWidth,
  },
  logoHolder: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  headerNavbar: {
    paddingRight: '5px',
    '@media (min-width: 600px)': {
      minHeight: '72px',
    },
  },
  headerHelpHolder: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '17px',
    fontWeight: '500',
    color: '#CED1D6',
    '& div': {
      padding: '0 8px',
      color: theme.palette.primary.darkGrey,
      cursor: 'pointer',
      display: 'grid',
      alignItems: 'center',
      gap: '4px',
      fontSize: '12px',
      gridTemplateColumns: 'auto auto',
      '&:first-child': {
        borderLeft: '0',
      },
    },
  },
  mobileNavigation: {
    borderTop: '3px solid #EBEEF3',
    position: 'fixed',
    bottom: '0',
    right: '0',
    left: '0',
    background: '#fff',
    color: '#484456',
    zIndex: '1020',
    height: '68px',
    overflow: 'auto',
    justifyContent: 'flex-start',
    textAlign: 'center',
    '& button': {
      padding: '6px 6px 8px',
    },
    '& a': {
      padding: '6px 6px 8px',
      minWidth: '70px',
    },
    '& svg': {
      color: '#130F26',
      marginBottom: '6px',
    },
    '& span': {
      fontSize: '9px!important',
    },
    '& $Menuselected': {
      '& svg': {
        color: '#D2374F',
      },
      '& span': {
        color: '#342D3D',
        fontWeight: '500',
      },
    },
    [theme.breakpoints.up('xs')]: {
      display: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
    },
  },

  loginButton: {
    textTransform: 'none',
    height: '40px',
    fontWeight: 500,
    minWidth: '86px',
    bordercolor: theme.palette.primary.main,
    borderRadius: '4px',
    padding: '16px, 24px, 16px, 24px',
  },

  iconButtons: {
    maxWidth: '40px',
    maxHeight: '40px',
    minWidth: '40px',
    minHeight: '40px',
    padding: '10px',
    marginLeft: '8px',
    borderColor: '#fff',
    borderRadius: '0px',
    '& img': {
      width: '18px',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '32px',
      maxHeight: '32px',
      minWidth: '32px',
      minHeight: '32px',
      padding: '10px',
      marginLeft: '7px',
    },
  },
  iconsButtonBlack: {
    maxWidth: '40px',
    maxHeight: '40px',
    minWidth: '40px',
    minHeight: '40px',
    padding: '10px',
    marginLeft: '8px',
    borderColor: '#000',
    borderRadius: '0px',
    border: 'none',
    '& img': {
      width: '18px',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '32px',
      maxHeight: '32px',
      minWidth: '32px',
      minHeight: '32px',
      padding: '10px',
      marginLeft: '5px',
    },
  },
  iconBellIcon: {
    marginRight: '5px',
    border: 'none',
    padding: '0px',
    minWidth: 'auto',
  },
  iconsButtonMobile: {
    maxWidth: '24px',
    maxHeight: '24px',
    minWidth: '24px',
    minHeight: '24px',
    borderRadius: '0px',
    padding: '10px',
    marginLeft: '5px',
  },

  Menuselected: {},
  '@media (max-width: 429px)': {
    loginSignupOpener: {
      margin: '0',
      textTransform: 'none',
    },
    maintainance: {
      background: theme.palette.primary.main,
      textAlign: 'center',
      color: '#ffffff',
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '20px',
    },

    successImg: {
      width: '20px',
      height: '20px',
    },
  },
  btnPrimary: {
    background: theme.palette.primary.white,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    padding: '16px 24px',
    borderRadius: '0',
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
    },
  },

  commChannelContainer: {
    position: 'fixed',
    bottom: '0px',
    right: '0px',
    display: 'flex',
    alignItems: 'end',
    zIndex: '9999',
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.5)',
    backdropFilter: 'blur(5px)',
    top: '0px',
    width: '200%',
    zIndex: '9999',
  },
  communicationLogo: {
    width: '80px',
    height: '80px',
    cursor: 'pointer',
  },
  channel: {
    position: 'absolute',
    right: '15px',
    bottom: '100px',
    [theme.breakpoints.down('xs')]: {
      bottom: '160px !important',
      right: '25px',
    },
  },
  channelDiv: {
    display: 'flex',
    marginBottom: '195px',
    flexDirection: 'column',
    position: 'absolute',
    right: '90px',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '260px',
      right: '100px',
    },
  },
  btnDiv: {
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      display: 'inline-block',
      marginTop: '38px',
      width: '40px',
      height: '100px',
      borderTopRightRadius: '3px',
      borderTop: '2px solid white',
      borderRight: '2px solid white',
    },
  },
  dotCls: {
    background: 'white',
    borderRadius: '20px',
    width: '10px',
    height: '10px',
    display: 'inline-block',
    marginLeft: '-10px',
  },
  connectorDiv: {},
  channelBtns: {
    padding: '0px',
    margin: '12px 20px',
    borderBottomLeftRadius: '20px',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
    height: '56px',
    textTransform: 'none',
    background: 'white',
    width: '233px',
    fontSize: '18px',
    fontWeight: '500',
    '& img': {
      marginLeft: '-50px',
      marginTop: '3px',
      width: '75px',
    },
    '& a': {
      color: '#130F26',
      textDecoration: 'none',
    },
  },
  adgmChat: {
    marginLeft: '-58px !important',
    marginTop: '1px !important',
    width: '',
  },
  wChat: {
    width: '80px !important',
    marginLeft: `${theme.direction === 'rtl' ? '-60px !important' : '-40px !important'}`,
  },
  mobiletitlehead: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    // background: '#0D2A3A',
    alignItems: 'center',
    padding: '15px',
    borderBottom: '1px solid rgb(213 214 215 / 40%)',
    zIndex: '99',
    '& $ownerAvatarimg': {
      flexShrink: '0',
      marginRight: '10px',
    },
    '& h2': {
      fontSize: '12px',
      fontWeight: '500',
    },
  },
  loginButtonSmall: {
    textTransform: 'none',
    height: '32px',
    minWidth: '70px',
    borderRadius: '0px',
    padding: '16px 24px',
    marginLeft: '5px',
    fontWeight: '500',
    [theme.breakpoints.down('xs')]: {
      padding: '0px 5px',
    },
  },
  staticDrawer: {
    position: 'absolute',
    width: '0%',
    height: '100%',
    right: '0px',
    zIndex: 99,
    display: 'flex',
    '& $gradientColor': {
      backgroundColor: '#F8F8F8',
      width: '100%',
      height: '100%',
      opacity: 0.1,
      visibility: 'hidden',
      transition: 'all 0.5s ease',
    },
    '& $content': {
      width: '0%',
      height: '100%',
      backgroundColor: '#fff',
      position: 'fixed',
      right: '0px',
      paddingTop: '72px',
      visibility: 'hidden',
      transition: 'all 0.5s ease',
    },
  },
  staticOpen: {
    width: '100%',
    '& $gradientColor': {
      opacity: 0.4,
      visibility: 'inherit',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    '& $content': {
      width: '30%',
      visibility: 'inherit',
      minWidth: '500px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        minWidth: 'auto',
      },
    },
  },
  gradientColor: {},
  content: {},

  morePopup: {
    zIndex: 999,
    '& $content': {
      backgroundColor: '#F8F8F8',
      paddingTop: '0px',
    },
  },
  withLogin: {
    position: 'fixed',
    backgroundColor: '#fff',
    color: '#000',
    borderBottom: '1px solid #EAEBEB',
  },
  en: {
    fontFamily: 'Gilroy !important',
  },
});

export default styles;
